export default "__VITE_ASSET__5y5u0t2cm0pZnJCtI27VXQ__"